<!-- Content -->
@if (question && trainingResult && (trainingSharedFacade.currentSelectedSlidePage$ | async); as trainingPage) {
  <div class="d-flex"
    role="group"
    >
    <!-- Show Answer -->
    @if (trainingResult.showFeedback === false) {
      <button type="button"
        class="mdsf-btn m-2 mdsf-btn-primary"
        role="button"
        (click)="setShowFeedback(trainingPage)"
        translate="check_answer">
      </button>
    }
    @if (trainingResult.showFeedback) {
      <button type="button"
        class="mdsf-btn m-2"
        role="button"
        disabled
        >
        {{ 'check_answer_done' | translate }} <i class="fa fa-fw fa-times"></i>
      </button>
    }
    <!-- Show Explanation -->
    @if (question.explanation && trainingResult.showFeedback) {
      @if (trainingResult.showExplanation === false) {
        <button type="button"
          class="mdsf-btn m-2 ml-3 mdsf-btn-primary"
          role="button"
          (click)="toggleShowExplanation()"
          translate="show_explanation">
        </button>
      }
      @if (trainingResult.showExplanation) {
        <button type="button"
          class="mdsf-btn m-2 ml-3"
          role="button"
          (click)="toggleShowExplanation()">
          {{ 'show_explanation_done' | translate }}  <i class="fa fa-fw fa-times"></i>
        </button>
      }
    }
    <!-- Question Required -->
    @if (showRequired && trainingResult.showFeedback === false) {
      <p class="d-flex justify-content-center align-items-center m-2 ml-3 question-required"
        >
        <i class="fa fa-exclamation-triangle mr-2"></i>
        {{ 'question_required' | translate }}
      </p>
    }
  </div>
}
